<template>
  <admin>
    <h1></h1>
  </admin>
</template>

<script>
export default {};
</script>

<style>
</style>